import { render, staticRenderFns } from "./broadcastNew.vue?vue&type=template&id=06b25655&scoped=true&"
import script from "./broadcastNew.vue?vue&type=script&lang=js&"
export * from "./broadcastNew.vue?vue&type=script&lang=js&"
import style0 from "./broadcastNew.vue?vue&type=style&index=0&id=06b25655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b25655",
  null
  
)

export default component.exports